export type AnyFn = any | ((...params: any[]) => any);

export function anyFnExec(anyFn: AnyFn, ...params: any[]): any {
  if (!anyFn) {
    return;
  }

  return typeof anyFn === 'function' ? anyFn(...params) : anyFn;
}
